import React from 'react';
import { useTranslation } from 'react-i18next';

const SeriesSection = () => {
  const { t } = useTranslation();

  const series = [
    {
      id: 'marbella',
      title: t('series.marbella.title'),
      description: t('series.marbella.description'),
      image: '/images/series/marbella-vice.png',
      type: 'Roleplay',
      platform: 'GTA V'
    },
    {
      id: 'egoland',
      title: t('series.egoland.title'),
      description: t('series.egoland.description'),
      image: '/images/series/egoland.jpg',
      type: 'Survival',
      platform: 'Rust'
    },
    {
      id: 'catorce_dias',
      title: t('series.catorce_dias.title'),
      description: t('series.catorce_dias.description'),
      image: '/images/series/14-dias.jpg',
      type: 'Survival Horror',
      platform: 'DayZ'
    },
    {
      id: 'permadeath',
      title: t('series.permadeath.title'),
      description: t('series.permadeath.description'),
      image: '/images/series/permadeaz.jpg',
      type: 'Hardcore',
      platform: 'Project Zomboid'
    },
    {
      id: 'tarde_oldschool',
      title: t('series.tarde_oldschool.title'),
      description: t('series.tarde_oldschool.description'),
      image: '/images/series/tarde-oldschool.jpg',
      type: 'Torneo',
      platform: 'Call of Duty MW3'
    },
    {
      id: 'lights_out',
      title: t('series.lights_out.title'),
      description: t('series.lights_out.description'),
      image: '/images/series/lights-out.jpg',
      type: 'Survival Horror',
      platform: 'DayZ'
    }
  ];

  return (
    <section className="twitch-series">
      <div className="container">
        <h2 className="section-title">{t('series.title')}</h2>
        <p className="text-center mb-2" style={{ color: '#cccccc', fontSize: '1.2rem' }}>
          {t('series.subtitle')}
        </p>
        <div className="series-grid">
          {series.map((serie) => (
            <div key={serie.id} className="series-card">
              <div className="series-image-container">
                <img 
                  src={serie.image} 
                  alt={serie.title} 
                  className="series-image"
                />
                <div className="series-overlay">
                  <span className="series-type">{serie.type}</span>
                  <span className="series-platform">{serie.platform}</span>
                </div>
              </div>
              <h3>{serie.title}</h3>
              <p>{serie.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SeriesSection;
